import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useMatch } from 'react-router-dom';

function LanguageWrapper() {
    const { i18n } = useTranslation();
    const match = useMatch('/:lang/*');
    const lang = match?.params.lang;

    useEffect(() => {
        if (i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    return <Outlet />; // This is where nested route components will be rendered
}

export default LanguageWrapper;
